import { useQuery } from "@/compat/reactQuery";
import queryKeys from "../../../constants/queryKeys";
import templateService from "../../services/templateService";

const useModuleTemplates = ({
    moduleArea,
    pageNum,
    rowsPerPage,
    accountId,
    siteExternalIds,
    sortOrder,
    orderByColumn,
    templateType,
    sectorId,
    subjectId,
    frequency,
    filterText,
    isEnabled,
}) =>
    useQuery(
        [
            queryKeys.templates,
            moduleArea,
            { page: pageNum, rows: rowsPerPage },
            accountId,
            siteExternalIds?.join(","),
            sortOrder,
            orderByColumn,
            templateType,
            sectorId,
            subjectId,
            frequency,
            filterText || "",
            isEnabled
        ],
        () =>
            templateService.fetchTemplatesForModule({
                moduleArea,
                pageNum,
                rowsPerPage,
                accountId,
                siteExternalIds,
                sortOrder,
                orderByColumn,
                templateType,
                sectorId,
                subjectId,
                frequency,
                filterText,
                isEnabled,
            }),
        {
            enabled:
                moduleArea !== null &&
                moduleArea !== undefined &&
                pageNum !== null &&
                pageNum !== undefined &&
                siteExternalIds?.length > 0,
        }
    );

export default useModuleTemplates;
